import { createSlice } from "@reduxjs/toolkit";
import { getLimsList } from "../../reduxApi/admin/LimsReduxApi"; // path apne project ke hisab se update kar lena

const limsSlice = createSlice({
    name: "Lims",
    initialState: {
        status: "idle",
        isFiltered: false,
        lims: [],
    },

    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },

        deleteLimsAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.lims.findIndex(
                    (item) => item.ROWID === id
                );

                if (index !== -1) {
                    state.lims.splice(index, 1);
                }
            });
        },

        updateLimsAction: (state, action) => {
            const index = state.lims.findIndex(
                (item) => item.ROWID === action.payload.ROWID
            );

            if (index !== -1) {
                state.lims[index] = action.payload;
            }
        },

        addLimsAction: (state, action) => {
            state.lims.unshift(action.payload);
        },

        clearFilters: (state) => {
            state.isFiltered = false;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getLimsList.pending, (state) => {
                state.status = "pending";
            })

            .addCase(getLimsList.fulfilled, (state, action) => {
                state.status = "fulfilled";
                state.lims = action.payload?.data || action.payload
            })

            .addCase(getLimsList.rejected, (state) => {
                state.status = "rejected";
            });
    },
});

export const {
    deleteLimsAction,
    updateLimsAction,
    addLimsAction,
    setFilteredStatus,
    clearFilters,
} = limsSlice.actions;

export default limsSlice.reducer;